/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// helper
import { fontSizeBaseline, pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers'
// animations
import { slideIn, slideOut } from 'utils/styles/animations/types/slide';
import { fadeIn, fadeOut } from 'utils/styles/animations/types/fade';
import { flip, flipIn, flipOut } from 'utils/styles/animations/types/flip';
import { shake, headShake } from 'utils/styles/animations/types/shake';
import { wobble } from 'utils/styles/animations/types/wobble';
import { tada } from 'utils/styles/animations/types/tada';
// import { swing } from 'utils/styles/animations/types/swing';
// import { rubberBand } from 'utils/styles/animations/types/rubberband';
import { pulse } from 'utils/styles/animations/types/pulse';
import { jello } from 'utils/styles/animations/types/jello';
// import { hinge } from 'utils/styles/animations/types/hinge';
// import { flash } from 'utils/styles/animations/types/flash';
// import { lightSpeedIn, lightSpeedOut } from 'utils/styles/animations/types/lightspeed';
import { rollIn, rollOut } from 'utils/styles/animations/types/roll';
import { rotateIn, rotateOut } from 'utils/styles/animations/types/rotate';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// APP STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	// applies styles to the global scope, meaning it will affect all elements so use sparringly (http://cssinjs.org/jss-global)
    '@import': [
    	'url(https://use.fontawesome.com/releases/v5.5.0/css/all.css)', // used for icons
        'url(https://fonts.googleapis.com/css?family=Work+Sans)',
    ],
	'@global': {
		'html, body, #root': {
			// overflow: 'hidden',
			scrollBehavior: 'smooth', // animate scrolling for when we scroll to top based on history
			height: '100%' // needed for full size app (also needed to add #root div here)
		},
		html: {
			fontSize: fontSizeBaseline + 'px'
		},
		'*, *:before, *:after': {
			boxSizing: 'border-box',
			margin: '0',
			padding: '0'
		},
		body: {
			backgroundColor: 'transparent',
			color: theme.color.supporting.dark.swatch,
            fontFamily: theme.typography.font,
			fontWeight: 'normal',
			fontSize: '1rem',
			fontSmoothing: 'antialiased' // subpixel-antialiased // ***** needed to cleanup font clarity on webkit browsers ***** //
			// https://forum.webflow.com/t/a-fix-for-when-your-elements-move-up-and-or-blur-during-animations-interactions-on-chrome/11629
		},
		a: {
			color: theme.color.primary.medium.swatch,
			textDecoration: 'none',
			transition: 'color .2s linear 0s'
		},
		'a:hover': {
			filter: 'brightness(85%)',
			textDecoration: 'none'
		},
		'.accessibility': {
			display: 'none'
		},
		'.clump': {
			whiteSpace: 'nowrap'
		},
		// tooltip (override library theme color with custom colors)
		'.tippy-tooltip': {
			backgroundColor: '#D0EAFD !important',
			color: '#0D5D99 !important',
			fontSize: pxToEm(16),
			padding: replacePXinStringWithEM('10px 15px'),
			'& .list': {
				textAlign: 'left',
				'& .listitem': {
					display: 'flex',
					marginBottom: pxToEm(5),
					'& .text': {
						marginLeft: pxToEm(7)
					}
				}
			}
		},
		'.tippy-popper[x-placement^=top] [x-arrow]': {
			borderTopColor: '#D0EAFD !important'
		},
		'.tippy-popper[x-placement^=bottom] [x-arrow]': {
			borderBottomColor: '#D0EAFD !important'
		},
		'.tippy-popper[x-placement^=left] [x-arrow]': {
			borderLeftColor: '#D0EAFD !important'
		},
		'.tippy-popper[x-placement^=right] [x-arrow]': {
			borderRightColor: '#D0EAFD !important'
		}
	},
	// animations
	fadeOut, fadeIn,
	slideIn, slideOut,
	flip, flipIn, flipOut,
	shake, headShake,
	wobble,
	tada,
	// swing,
	// rubberBand,
	pulse,
	jello,
	// hinge,
	// flash,
	// lightSpeedIn, lightSpeedOut,
	rollIn, rollOut,
	rotateIn, rotateOut,
	app: {
		// scrollBehavior: 'smooth', // animate scrolling for when we scroll to top based on history
		height: '100%',
		// overflow: 'auto'
	}
});